import { useState } from 'react';
import { useAuth } from './auth/AuthProvider';
import { keycloakClient } from './auth/keycloak';
import { useI18n } from './i18n/I18nProvider';
import LanguageSwitcher from './i18n/LanguageSwitcher';
import NotificationInbox from './NotificationInbox';

const roleOrder = ['ADMIN', 'OFFICE', 'DRIVER', 'CLIENT'];

export default function SidebarProfile() {
  const auth = useAuth();
  const { t } = useI18n();
  const identity = keycloakClient()?.tokenParsed || {};
  const username = identity.preferred_username || identity.email || 'DriverOS';
  const displayName = identity.name || [identity.given_name, identity.family_name].filter(Boolean).join(' ') || username;
  const role = roleOrder.find((value) => auth.roles?.has(value));
  const initials = displayName.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join('').toUpperCase() || 'DO';
  const [unread, setUnread] = useState(0);

  return <details className="sidebar-profile">
    <summary aria-label={t('common.profile')}>
      <span className="sidebar-profile-avatar" aria-hidden="true">{initials}{unread > 0 && <b className="sidebar-profile-notification-badge">{unread > 99 ? '99+' : unread}</b>}</span>
      <span className="sidebar-profile-copy"><b>{displayName}</b><small>{role ? t(`roles.${role}`) : username}</small></span>
      <i aria-hidden="true" />
    </summary>
    <div className="sidebar-profile-panel">
      <span>{t('common.accountSettings')}</span>
      <NotificationInbox compact onUnreadChange={setUnread} />
      <LanguageSwitcher compact />
      {auth.enabled && <button type="button" onClick={auth.logout}>{t('common.signOut')}</button>}
    </div>
  </details>;
}
